/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ActivityIndicator,
} from 'react-native';
// eslint-disable-next-line no-unused-vars
import { useDispatch, useSelector } from 'react-redux';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useFormikContext } from 'formik';
import * as Linking from 'expo-linking';

import { Loader } from '@components/screen/Layout';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import WebViews from '@/plugins/webview';
import Image from '@components/global/Image';
import SelectBox from '@components/form/SelectBox';
import ModalFull from '@components/modal/ModalFull';

import useLocation from '@/hooks/useLocation';
import { formLabel, formControlContainer } from '@assets/styles/formStyles';
import { getAddress, search } from '@api/nominatim';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';
import { generateGMapsLink } from '@global/helpers';

function getMapScript(location, disabled, zoom = 17) {
  let disabledCode = '';
  if (disabled) {
    disabledCode = `
			map._handlers.forEach(function(handler) {
				handler.disable();
			});
			map.removeControl(map.zoomControl);
		`;
  }
  return `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Sociolla Map Picker</title>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css" crossorigin=""/>
            <script src="https://unpkg.com/leaflet@1.6.0/dist/leaflet.js" crossorigin=""></script>
        </head>
        <body style="margin:0;padding:0;">
        <div id="map" style="width: 100vw; height: 100vh;"></div>
        <script>
            var curLocation = [${location.lat ? location.lat : -6.187755}, ${
    location.lng ? location.lng : 106.7387891
  }];

            var map = L.map('map').setView(curLocation, ${zoom});

            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            }).addTo(map);

            var marker = new L.marker(curLocation, {
            	draggable: ${!disabled}
            });

            marker.on('dragend', function(event) {
                var position = marker.getLatLng();
                marker.setLatLng(position, {
                    draggable: 'true'
                }).bindPopup(position).update();
				var payloadStr = JSON.stringify(position);
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(payloadStr);
				} else {
					window.postMessage(payloadStr);
				}
            });

            map.addLayer(marker);

			${disabledCode}

        </script></body>
        </html>
    `;
}

const dimension = Dimensions.get('window');

function SociollaOpenStreetMaps(props) {
  const {
    value,
    disabled = false,
    editable = true,
    hideInput = false,
    label,
    height = 220,
    containerStyle = {},
    // eslint-disable-next-line no-unused-vars
    mapContainerStyle = {},
    onChange,
    onCurrentLocation,
    onChangeAddress,
  } = props;
  const webViewRef = useRef();
  const currentLocation = useLocation();
  const dispatch = useDispatch();

  let form = null;
  if (editable) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    form = useFormikContext();
  }

  const insets = useSafeAreaInsets();
  const screenHeight = isWeb
    ? 'auto'
    : dimension.height - insets.top - insets.bottom;

  const [place, setPlace] = useState('');
  const [loc, setLoc] = useState('');
  const [html, setHtml] = useState('');
  const [modalHtml, setModalHtml] = useState('');
  const [modal, setModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setModalHtml('');
    setModalHtml(
      getMapScript(
        {
          lat: loc?.latitude ? loc.latitude : currentLocation.latitude,
          lng: loc?.longitude ? loc.longitude : currentLocation.longitude,
        },
        false,
        14,
      ),
    );
    setModal(true);
  };

  const getMapDetail = async (latLong) => {
    const reverse = await getAddress({
      params: {
        format: 'json',
        lat: latLong.latitude,
        lon: latLong.longitude,
      },
    });
    if (reverse?.data?.address) {
      try {
        onChangeAddress({
          state: reverse?.data?.address?.city,
          city: reverse?.data?.address?.city_district,
          postal_code: reverse?.data?.address?.postcode,
          street: reverse?.data?.display_name,
        });
      } catch (error) {}
    }
  };

  const onSubmit = (location = null, picked = false) => {
    const newLocation = {
      latitude: location?.latitude ? location.latitude : loc.latitude,
      longitude: location?.longitude ? location.longitude : loc.longitude,
    };
    if (newLocation.latitude && newLocation.longitude) {
      webViewRef.current.injectJavaScript(`
                map.setView([${newLocation.latitude}, ${newLocation.longitude}], 17);
                map.addLayer(new L.marker([${newLocation.latitude}, ${newLocation.longitude}], {
                    draggable: ${picked}
                }));
            `);
      onChange(newLocation);
      if (picked) {
        getMapDetail(newLocation);
      } else {
        setModal(false);
      }
    }
  };

  const mapClicked = async (type, pickValue = {}) => {
    if (type === 'current') {
      if (onCurrentLocation) {
        getReverse({
          lat: currentLocation.latitude,
          lng: currentLocation.longitude,
        }).then((response) => {
          if (response.status === 200) {
            onCurrentLocation(response.data);
          }
        });
      }
    } else if (type === 'address') {
      showModal();
      setPlace('');

      // Move search to modal
      // form.setErrors({});
      // form.setTouched({});
      // let valid = true;
      // let payload = {
      // 	format: 'json',
      // 	limit: 1,
      // 	//polygon_geojson: 1,
      // };
      // if (form.values.state?.name) {
      // 	payload.state = form.values.state.name
      // } else {
      // 	valid = false;
      // 	form.setFieldTouched('state', true);
      // }
      // if (form.values.city?.name) {
      // 	payload.city = form.values.city.name
      // } else {
      // 	valid = false;
      // 	form.setFieldTouched('city', true);
      // }
      // if (form.values.street) {
      // 	payload.q = form.values.street
      // } else {
      // 	valid = false;
      // 	form.setFieldTouched('street', true);
      // }

      // if (payload.country && payload.state && payload.city && payload.q) {
      // 	const street_value = (payload.q.toLowerCase().indexOf('jalan') > -1 ? payload.q : `jalan ${payload.q}`)
      // 	payload.q = `${street_value}, ${payload.city}, ${payload.state}, ${payload.country}`
      // 	delete payload.city
      // 	delete payload.state
      // 	delete payload.country
      // }

      // if (valid) {
      // 	setLoading(true);
      // 	try {
      // 		const response = await search({ params: payload });
      // 		if (response.data.length) {
      // 			setLoc({ latitude: response.data[0].lat, longitude: response.data[0].lon });
      // 			onSubmit({ latitude: response.data[0].lat, longitude: response.data[0].lon });
      // 			setPlace(response.data[0].display_name || '');
      // 			setLoading(false);
      // 		} else {
      // 			getReverse({
      // 				lat: currentLocation.latitude,
      // 				lng: currentLocation.longitude
      // 			}).then(response => {
      // 				setLoc({ latitude: currentLocation.latitude, longitude: currentLocation.longitude });
      // 				onSubmit({ latitude: currentLocation.latitude, longitude: currentLocation.longitude });
      // 				setLoading(false);
      // 				showModal();
      // 			})
      // 		}
      // 	} catch (e) {
      // 		console.log(e);
      // 		setLoading(false);
      // 	}
      // }
    } else if (type === 'picked') {
      const latLong = {
        latitude: pickValue.latitude,
        longitude: pickValue.longitude,
      };
      setLoc(latLong);
      onSubmit(latLong, true);
      setPlace(pickValue.name || '');
      setModalHtml('');
      setTimeout(() => {
        setModalHtml(
          getMapScript(
            {
              lat: latLong.latitude,
              lng: latLong.longitude,
            },
            false,
            14,
          ),
        );
      }, 250);
    } else if (type === 'url') {
      Linking.openURL(generateGMapsLink(loc.latitude, loc.longitude));
    }
  };

  const setLocation = (location) => {
    if (location?.lat && location?.lng && !html) {
      setHtml(getMapScript(location, disabled));
      setLoc({ latitude: location.lat, longitude: location.lng });
    }
  };

  const getReverse = async (payload, changeData = true) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await getAddress({
        params: {
          format: 'json',
          lat: payload.lat,
          lon: payload.lng,
        },
      });
      if (changeData) {
        onChange({ latitude: payload.lat, longitude: payload.lng });
      } else {
        setLoc({ latitude: payload.lat, longitude: payload.lng });
      }
      setPlace(response.data.display_name || '');
      dispatch(showPopup({ name: 'isLoading', value: false }));
      return response;
    } catch (e) {
      console.log(e);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      return false;
    }
  };

  const getLocation = async (data) => {
    setLoc('');
    if (typeof data.data !== 'string') {
      return false;
    }
    const location = JSON.parse(data.data);
    if (location.lat && location.lng) {
      getReverse(location, false);
    }
  };

  useEffect(() => {
    let mounted = false;
    if (props.value && !mounted) {
      if (form?.values?.street && !place) {
        setPlace(form?.values?.street);
      }
      setLocation({
        lat: props.value.latitude,
        lng: props.value.longitude,
      });
    }
    return () => {
      mounted = true;
    };
  }, [props.value]);

  useEffect(() => {
    let isMounted = false;
    if (currentLocation?.latitude && currentLocation?.longitude && !isMounted) {
      setLocation({
        lat: currentLocation.latitude,
        lng: currentLocation.longitude,
      });
    }
    return () => {
      isMounted = true;
    };
  }, [currentLocation]);

  return (
    <View style={[formControlContainer, containerStyle]}>
      {label && <SociollaText style={formLabel}>{label}</SociollaText>}
      {value ? (
        <View
          style={[
            styles.mapContainer,
            { height, top: label ? 35 : 7, alignItems: 'flex-start', left: 7 },
          ]}>
          {editable ? (
            <Button
              rounded={false}
              buttonStyle={{
                width: 30,
                height: 30,
                borderRadius: 4,
                backgroundColor: Colors.white,
                borderColor: Colors.white,
                shadowColor: Colors.black,
                shadowOffset: {
                  width: 0,
                  height: 1,
                },
                shadowOpacity: 0.65,
                shadowRadius: 5,
              }}
              title={
                <Image
                  style={{ width: 14, height: 14 }}
                  width={14}
                  height={14}
                  svg={true}
                  source={require('@assets/img/icons/edit-blue.svg')}
                />
              }
              onPress={showModal}
            />
          ) : (
            <TouchableOpacity
              style={{ height: '100%', width: '100%' }}
              onPress={() => mapClicked('url')}>
              <View />
            </TouchableOpacity>
          )}
        </View>
      ) : (
        <View
          style={[
            styles.mapContainer,
            styles.overlayBackground,
            {
              height,
              top: label ? 28 : 0,
              alignItems: 'center',
              justifyContent: 'center',
            },
          ]}>
          {loading ? (
            <>
              <SociollaText
                type="medium"
                style={{ fontSize: 12, color: Colors.grey13 }}>
                finding location...
              </SociollaText>
              <ActivityIndicator
                size="small"
                color={Colors.blue0}
                style={{ marginTop: 30 }}
              />
            </>
          ) : (
            <>
              <View style={{ flexDirection: 'row', marginBottom: 20 }}>
                <Image
                  style={{ width: 14, height: 14 }}
                  width={14}
                  height={14}
                  svg={true}
                  source={require('@assets/img/icons/attention-red.svg')}
                />
                <SociollaText
                  style={{ marginLeft: 8, fontSize: 12, color: Colors.red3 }}>
                  Address pinpoint not set
                </SociollaText>
              </View>
              <Button
                rounded={true}
                buttonStyle={{
                  width: 200,
                }}
                title="Use current location"
                onPress={() => mapClicked('current')}
              />
              {form && form.values && (
                <Button
                  rounded={true}
                  buttonStyle={{
                    width: 200,
                    marginTop: 10,
                  }}
                  title="Find by street address"
                  onPress={() => mapClicked('address')}
                />
              )}
            </>
          )}
        </View>
      )}
      <View style={{ height, marginBottom: 10, zIndex: -1, borderRadius: 4 }}>
        {html ? (
          <WebViews
            ref={webViewRef}
            originWhitelist={['*']}
            source={{ html }}
            javaScriptEnabled={true}
            domStorageEnabled={true}
            startInLoadingState={true}
            style={{ height, flex: 1 }}
            onMessage={getLocation}
          />
        ) : (
          <Loader />
        )}
      </View>
      {
        !hideInput && (
          <View style={{ width: '100%' }}>
            <SelectBox
              label="Find Address"
              hideLabel={true}
              options={[]}
              value={place}
              trackBy="id"
              labelKey="name"
              placeholder="No location pinned"
              isMap="osm"
              mapApi={search}
              style={{ width: '100%' }}
              onChange={(value) => {
                if (value) {
                  setPlace(value.name);
                  mapClicked('picked', value);
                }
              }}
            />
          </View>
        )
        // <Input
        // 	value={place}
        // 	placeholder={'No Location Pinned'}
        // 	multiline={true}
        // 	numberOfLines={4}
        // 	// disabled={true}
        // 	onChangeText={(val) => {
        // 		setPlace(val)
        // 		onSearchByText(val)
        // 	}}
        // />
      }
      {modal && (
        <ModalFull
          show={modal}
          title="Set Location"
          width={isWeb ? 650 : '100%'}
          onClose={() => setModal(false)}>
          <View
            style={{
              height: isWeb ? 500 : screenHeight - 200,
              marginBottom: 10,
              borderRadius: 4,
            }}>
            {modalHtml ? (
              <WebViews
                originWhitelist={['*']}
                source={{ html: modalHtml }}
                javaScriptEnabled={true}
                domStorageEnabled={true}
                startInLoadingState={true}
                style={{ height: isWeb ? 500 : screenHeight - 200 }}
                onMessage={getLocation}
                onClick={mapClicked}
              />
            ) : (
              <Loader />
            )}
          </View>
          <View style={{ paddingHorizontal: 20, alignItems: 'center' }}>
            <View style={{ width: '100%' }}>
              <SelectBox
                label="Find Address"
                hideLabel={true}
                options={[]}
                value={place}
                trackBy="id"
                labelKey="name"
                placeholder="No location pinned"
                isMap={true}
                style={{ width: '100%' }}
                onChange={(value) => {
                  if (value) {
                    setPlace(value.name);
                    mapClicked('picked', value);
                  }
                }}
              />
            </View>
            {/* <Input
							value={place}
							placeholder={'No Location Pinned'}
							multiline={isWeb ? false : true}
							numberOfLines={isWeb ? 1 : 4}
							// disabled={true}
							onChangeText={(val) => {
								setPlace(val)
								onSearchByText(val)
							}}
						/> */}
            <View
              style={[
                isWeb ? { marginTop: 20, flex: 1 } : buttonFloating,
                isWeb
                  ? { justifyContent: 'center', width: 200, marginBottom: 20 }
                  : {
                      position: 'relative',
                      elevation: 0,
                      marginTop: 20,
                      width: '100%',
                    },
                { bottom: 0 },
              ]}>
              <Button
                buttonStyle={{ ...buttonRounded, width: '100%' }}
                disabledStyle={{ ...buttonRounded, width: '100%' }}
                disabled={!place}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    Submit
                  </SociollaText>
                }
                onPress={onSubmit}
              />
            </View>
          </View>
        </ModalFull>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mapContainer: {
    zIndex: 99,
    position: 'absolute',
    width: '100%',
    borderRadius: 4,
  },
  overlayBackground: {
    //backgroundColor: '#00000060',
    backgroundColor: Colors.grey12,
  },
});

export default SociollaOpenStreetMaps;
